import { IImageStyles } from "@fluentui/react";
import { highContrastMedia } from "../../styles/media";
import { BorderRadius, ImageGradientType } from "./Image.types";

export const getImageStyles = (grayscale?: boolean, disabled?: boolean, borderRadius?: BorderRadius, enableHighContrastMode?: boolean, imageGradientType?: ImageGradientType) => {
    const styles: Partial<IImageStyles> = { image: {} };
    if (borderRadius) {
        styles.image!["borderRadius"] = borderRadius;
    }
    if (grayscale) {
        styles.image!["filter"] = "grayscale(100%)";
    }
    if (disabled) {
        styles.image!["opacity"] = "0.5";
    }
    if (enableHighContrastMode) {
        styles.image![highContrastMedia.whiteOnBlack] = {
            filter: "invert(100%)"
        };
    }
    if (imageGradientType) {
        switch (imageGradientType) {
            case "toLeft":
                styles.image!["-webkit-mask-image"] = "linear-gradient(to left, #fff, transparent);";
                break;
            case "toBottom":
                styles.image!["-webkit-mask-image"] = "linear-gradient(to bottom, #fff, transparent);";
                break;
            case "toRight":
                styles.image!["-webkit-mask-image"] = "linear-gradient(to right, #fff, transparent);";
                break;
            case "toTop":
                styles.image!["-webkit-mask-image"] = "linear-gradient(to top, #fff, transparent);";
                break;
        }
    }
    return styles;
};
